module.exports = __webpack_public_path__ + "img/SketchPng29e2bca445784b8d3e5586b7c03a68e7ebb8316e3c64559dfa2acf254d1fe3cc.a4a0d0fa.png";